import { useQuery } from '@tanstack/react-query';

import { getCategoryPageData } from '../api/categoryApi';

export const categoryPageQueryKeys = {
  all: ['category-page'] as const,
  page: (slug: string) => [...categoryPageQueryKeys.all, 'page', slug] as const,
};

export const useCategoryPageData = (params: { slug: string }) => {
  return useQuery({
    queryKey: categoryPageQueryKeys.page(params.slug),
    queryFn: () => getCategoryPageData(params),
  });
};
